export default "__VITE_ASSET__BKSFsTdX__"